
const base64Encode = async (token) => {
    return btoa(encodeURIComponent(token).replace(/%([0-9A-F]{2})/g, (_, p1) => {
        return String.fromCharCode('0x' + p1);
    }));
}


const General = {
    base64Encode
}

export default General
